// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Loader, Toastr } from "../../../revvComponents";

// Component Imports
import {
  Conditional,
  // CustomGrid,
  RevvGrid,
} from "../../../commonComponents";
import { DealTableBar } from "../../ControlBar";
import AgGridVisibilityCtrl from "../../AgGridVisibilityCtrl";
import NetPriceRounding from "../../ControlBar/DealTableBar/NetPriceRounding";
import DealTableEmptyScreen from "../DealTableEmptyScreen";

// Actions Imports
import { DealTableActions, QuotationActions } from "../../../actions";
import { updateDynamicFieldsInDocForCatalog } from "../../../actions/DocumentActions";
// Internal Imports
import { PriceMatrixRenderer } from "../../AgGridCellRenderer";
import { GlobalUtils } from "../../../utils";
import { COMMON, GRID, QUOTES, TOOLPANE } from "../../../constants";
// Destructuring
const { APP_FLAGS, CURRENCY_SYMBOL, TABLE_TYPE } = COMMON;
const { DEALTABLE_COLUMNS } = GRID;
const { GRID_PAGE_TYPE } = GRID;
const { TABS_LIST } = QUOTES;
const { TOOLPANE_TTITLE } = TOOLPANE;
const { checkAppFlag, readCookie, setProductPricebookCatalogClause } =
  GlobalUtils;
const { updateToolPaneData } = QuotationActions;
const {
  netPriceRounding,
  onCellValueChange,
  onGroupDiscountUpdate,
  onRowDelete,
  applySorting,
  applyColumnWidth,
} = DealTableActions;

class NewDealTable extends Component {
  state = {
    groupBy: "",
    manageColumnPopUp: false,
    manageNetPriceRoundingPopUp: false,
    pricingCellValue: "",
    pricingColumnData: {},
    pricingData: {},
    pricingPopUp: false,
    rowIndex: "",
    showLoader: false,
  };

  componentDidMount() {
    this._onInit();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.rowData.length === 0 && prevState.groupBy) {
      return { groupBy: "" };
    }
    return null;
  }

  _groupApply = data => {
    this.setState({
      groupBy: data,
    });
  };

  onUpdateDiscount = (groupMeta, value) => {
    const {
      metaData: { fieldMapIndex },
      dealTableId,
      discount,
      rowData,
    } = this.props;
    const discountClone = JSON.parse(JSON.stringify(discount));
    const netPriceFld = fieldMapIndex[DEALTABLE_COLUMNS.NET_PRICE];
    this.props.onGroupDiscountUpdate(
      rowData,
      discountClone,
      netPriceFld,
      dealTableId,
      groupMeta.group_by_value,
      value,
    );
  };

  /**
   * * _togglePopUp func decided the show/hide properties of children components
   * @param {string} type - Contains the key name of children component.
   * @param {Boolean} flag - Contains true/false flag.
   */
  _togglePopUp = (type, flag) => {
    this.setState({ [type]: flag });
  };

  /**
   * * _netPriceRounding func rounds off the net amount based on the user selection say,
   * *  by decimal, units, 10's, etc.,
   * @param {string} roundBy - Contains the type (by decimal, units, 10's) of roundoff method.
   */
  _netPriceRounding = roundingType => {
    const { dealTableId, discount, metaData, rowData } = this.props;
    this.setState({ showLoader: true, manageNetPriceRoundingPopUp: false });
    this.props
      .netPriceRounding(roundingType, rowData, metaData, discount, dealTableId)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Rounding method applied!",
          timeout: 3000,
        });
        this.setState({ showLoader: false });
      })
      .catch(error => {
        console.error("DealTableGrid => _netPriceRounding", error);
        this.setState({ showLoader: false });
      });
  };

  _onCellValueChanged = params => {
    const { dealTableId, rowData } = this.props;
    this.props.onCellValueChange(
      params.columnData,
      params.row,
      params.rowIndex,
      rowData,
      dealTableId,
    );
  };

  _deleteRow = (rowInfo, groupMeta, groupLength) => {
    const { dealTableId } = this.props;
    this.setState({ showLoader: true }, () => {
      this.props
        .onRowDelete(
          rowInfo.rowMeta,
          false,
          dealTableId,
          groupMeta,
          groupLength,
          this.state.groupBy,
        )
        .then(() => {
          const updatedAddedCatalogIds = this.props.addedCatalogIds[
            dealTableId
          ].filter(item => item !== rowInfo.rowMeta.index);
          const newdata = setProductPricebookCatalogClause(
            this.props.fields_used,
            updatedAddedCatalogIds,
            this.props.productCatalogs,
          );
          this.props.updateDynamicFieldsInDocForCatalog(
            this.props.documentId,
            newdata,
          );
          this.setState({ showLoader: false });
          Toastr.showToastr({
            type: "success",
            message: "Items have been removed successfully!",
            timeout: 1000,
          });
        })
        .catch(err => {
          console.error("DealTableGrid => _deleteRow", err);
        });
    });
  };

  _pricingData = (value, col, row, rowIndex) => {
    if (!this.state.pricingPopUp) {
      this.setState({
        pricingPopUp: true,
        pricingCellValue: value,
        pricingColumnData: col,
        pricingData: row,
        rowIndex,
      });
    }
  };

  _applySorting = col => {
    const { dealTableId, rowData, columnDefs } = this.props;
    this.props.applySorting(col, dealTableId, rowData, columnDefs);
  };

  _applyColumnWidth = widths => {
    this.props.applyColumnWidth(this.props.dealTableId, widths);
  };

  _onInit() {
    const {
      discount: { groups = [] },
      isLocked,
      isQuoteTable,
      metaData: { fieldMapIndex },
      rowData,
    } = this.props;
    /**
     *  If groups are applied then pass it to state so that whenever
     *  user loads the page the applied group will be selected and displayed
     *  in dealtable top bar
     */
    if (groups && groups.length > 0) {
      const column = groups[0].group_by.toLowerCase();
      this.setState({ groupBy: fieldMapIndex[column] });
    }
    /**
     * If rowData exists & if its empty then display the catalog pane to be displayed.
     */
    if (rowData.length === 0 && !isLocked && !isQuoteTable) {
      this.props.updateToolPaneData(
        true,
        TOOLPANE_TTITLE.CATALOG,
        TABS_LIST.DEAL_TABLE,
      );
    }
  }

  render() {
    const {
      columnDefs,
      currency,
      discount,
      isLocked,
      isQuoteTable,
      rowData,
      columnWidth,
    } = this.props;

    const hideDealDiscount =
      checkAppFlag(APP_FLAGS.DEAL_DISCOUNT) || isQuoteTable;

    return (
      <Fragment>
        <Conditional if={this.state.showLoader}>
          <Loader fullScreen />
        </Conditional>

        {/* To Handle no or quote table screen a dummy wrapper div is added */}
        <div
          className={`dealtablegrid-bar-container ${
            isQuoteTable ? "quote-table" : ""
          }`}>
          <Conditional if={this.props.columnDefs.length > 0 && !isQuoteTable}>
            {/* Code to show options bar in dealtable */}

            <DealTableBar
              togglePopUp={this._togglePopUp}
              groupKeyReference={this._groupApply}
            />

            {/* Manage Column btn popup code residing inside dealtable bar */}
            <Modal
              open={this.state.manageColumnPopUp}
              onClose={() => this._togglePopUp("manageColumnPopUp", false)}
              closeOnOverlayClick={false}
              center>
              <AgGridVisibilityCtrl
                page={GRID_PAGE_TYPE.DEALTABLE}
                title="Manage columns Visibility"
                togglePopUp={() =>
                  this._togglePopUp("manageColumnPopUp", false)
                }
              />
            </Modal>

            {/* Manage Column btn popup code residing inside dealtable bar */}
            <Modal
              open={this.state.manageNetPriceRoundingPopUp}
              onClose={() =>
                this._togglePopUp("manageNetPriceRoundingPopUp", false)
              }
              closeOnOverlayClick={false}
              center>
              {this.state.manageNetPriceRoundingPopUp && (
                <NetPriceRounding
                  togglePopUp={() =>
                    this._togglePopUp("manageNetPriceRoundingPopUp", false)
                  }
                  onSubmit={this._netPriceRounding}
                />
              )}
            </Modal>

            {this.state.pricingPopUp && (
              <PriceMatrixRenderer
                columnData={this.state.pricingColumnData}
                data={this.state.pricingData}
                rowIndex={this.state.rowIndex}
                togglePopUp={this._togglePopUp}
                value={this.state.pricingCellValue}
              />
            )}
          </Conditional>
        </div>

        <Conditional
          if={!this.state.showLoader && rowData && rowData.length === 0}>
          <div className="quotedetails-tab-contents">
            <div
              className={`dealtablegrid-wrapper ${
                hideDealDiscount ? "is-small" : ""
              }`}>
              <DealTableEmptyScreen
                isDocumentOwner={this.props.isDocumentOwner}
                isEmptyTable={this.props.columnDefs.length === 0}
                isLocked={this.props.isLocked}
                isQuoteTable={this.props.isQuoteTable}
              />
            </div>
          </div>
        </Conditional>

        <Conditional if={rowData && rowData.length > 0}>
          <Fragment>
            <div
              className={`dealtablegrid-wrapper ${
                hideDealDiscount ? "is-small" : ""
              }`}>
              <div className="dealtablegrid-container">
                <RevvGrid
                  columnData={columnDefs}
                  currencySymbol={CURRENCY_SYMBOL[currency]}
                  deleteRow={this._deleteRow}
                  discount={discount}
                  groupBy={this.state.groupBy}
                  onCellValueChanged={this._onCellValueChanged}
                  onUpdatedDiscountValue={this.onUpdateDiscount}
                  pricingPopUp={this._pricingData}
                  readOnly={isLocked || isQuoteTable}
                  rowData={rowData}
                  sortData={this._applySorting}
                  applyColumnWidth={this._applyColumnWidth}
                  columnWidth={columnWidth}
                />
              </div>
            </div>
          </Fragment>
        </Conditional>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  // ::QUOTATION STORE
  const { dealTableId, tableType } = state.QuotationStore;

  // ::DEALTABLE STORE
  const {
    columnDefs: { [dealTableId]: columnDefs = [] } = {},
    columnWidth: { [dealTableId]: columnWidth = {} } = {},
    discount: { [dealTableId]: discount = {} } = {},
    metaData = {},
    priceBook: { [dealTableId]: priceBook = {} } = {},
    rowData: { [dealTableId]: rowData = [] } = [],
    addedCatalogIds,
    productCatalogs,
  } = state.DealTableStore;

  // ::DOCUMENT STORE
  const {
    document: {
      fields_used,
      isLocked = false,
      created_by: { id: DocOwnerId = 0, id: documentId } = {},
    },
  } = state.DocumentStore;

  // ::ASSIGN REDUX KEYS TO RESPECTIVE DECLARED PROP VALUES
  const currency = (priceBook && priceBook.currency) || "USD";
  const isQuoteTable = tableType === TABLE_TYPE.QUOTE_TABLE;

  // ::ADDITION KEYS PASSED AS PROP VALUES
  const user = readCookie("user");
  let userData = {};
  if (user) {
    try {
      userData = JSON.parse(user);
    } catch (error) {
      console.error(`DealTableGrisV2 => mapStateToProps => Error => ${error}`);
    }
  }
  const isDocumentOwner = DocOwnerId === userData.id;

  return {
    columnDefs,
    columnWidth,
    currency,
    dealTableId,
    discount,
    isDocumentOwner,
    isLocked,
    isQuoteTable,
    metaData,
    rowData,
    addedCatalogIds,
    fields_used,
    productCatalogs,
    documentId,
  };
};
const mapDispatchToProps = {
  applySorting,
  applyColumnWidth,
  netPriceRounding, // (roundingType, rowData, metaData, discount, dealTableId)
  onCellValueChange, // (columnData, row, rowIndex, rowData, oldValue, newValue, dealTableId)
  onGroupDiscountUpdate,
  onRowDelete,
  updateToolPaneData, // (isOpen, view, page)
  updateDynamicFieldsInDocForCatalog,
};
export default connect(mapStateToProps, mapDispatchToProps)(NewDealTable);
